import { render, staticRenderFns } from "./FamilyList.vue?vue&type=template&id=0991c37e&scoped=true&"
import script from "./FamilyList.vue?vue&type=script&lang=js&"
export * from "./FamilyList.vue?vue&type=script&lang=js&"
import style0 from "./FamilyList.vue?vue&type=style&index=0&id=0991c37e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0991c37e",
  null
  
)

export default component.exports